import { compose } from "recompose";
import { withRouter } from "react-router-dom";
import withStyles from "@mui/styles/withStyles";
import { translate } from "../services/i18n/translate";

export const withRouterStylesAndTranslate = (styles) => (Component) =>
    compose(withStyles(styles), withRouter, translate)(Component);
